/*
 * @Author: MWeiLiu
 * @Date: 2019-12-17 20:14:00
 * @Last Modified by: MWeiLiu
 * @Last Modified time: 2021-04-25 22:19:48
 */

const notFind = {
  path: '/404',
  name: 'notFind',
  value: '404'
}

const index = {
  path: '/index',
  name: 'index',
  value: '首页'
}

const article = {
  path: '/article',
  name: 'article',
  value: '文章'
}

const activity = {
  path: '/activity',
  name: 'activity',
  value: '活动'
}

const activityDetails = {
  path: '/activityDetails/:id/:columnid',
  name: 'activityDetails',
  value: '活动详情'
}

const pay = {
  path: '/pay',
  name: 'pay',
  value: '支付'
}

export default {
  notFind,
  index,
  article,
  activity,
  activityDetails,
  pay
}



// WEBPACK FOOTER //
// ./src/router/mould.js